import ApiService from '@/services/api.service';

const AzureService = {
    getSpeechToken() {
        return ApiService.get('/AzureSpeech/token');
    },

    cleanUpTranscript(data) {
        return ApiService.post('/AzureAISession/cleanup-transcript', data);
    }
}

export default AzureService;